import { useQuery } from '@tanstack/react-query';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useWatch } from 'react-hook-form';
import ErrorToast, { showToast } from '../../../components/messages/ErrorAlert';
import { CompanySummary } from '../../../Interfaces/admin/User.interfaces';
import { fetchCompanies } from '../../../services/admin/UsersService';
import { CompaniesFilterArgs } from './CompaniesFilter';
import CompaniesTable from './CompaniesTable';

const statusToIsActive = (
  status: CompaniesFilterArgs['status']
): boolean | undefined => {
  if (status === 'active') return true;
  if (status === 'inactive') return false;
  return undefined;
};

const CompaniesTableContainer = () => {
  const [page, setPage] = useState(0);
  const filters = useWatch<CompaniesFilterArgs>();
  const [backupData, setBackupData] = useState<{
    companies: CompanySummary[];
    totalCompanies: number;
  }>({
    companies: [],
    totalCompanies: 0,
  });
  const [rowsAmount, setRowsAmount] = useState(15);
  const [backupPage, setBackupPage] = useState(0);
  const toast = useRef<Toast>(null);
  const isActive = statusToIsActive(filters.status);
  const showStatusColumn = filters.status === 'both';

  const { data, isFetching, isError } = useQuery({
    queryKey: [
      'getCompanies',
      page,
      rowsAmount,
      filters.source,
      filters.info,
      filters.status,
    ],
    queryFn: ({ signal }) => {
      return fetchCompanies(
        {
          page,
          amountPerPage: rowsAmount,
          source: filters.source,
          info: filters.info,
          isActive,
        },
        signal
      );
    },
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setBackupData({ companies: data.companies, totalCompanies: data.amount });
      setBackupPage(page);
    },
    onError: (error) => {
      showToast(
        'error',
        toast,
        'Search Companies Error',
        'An error ocurred! please try again later',
        3000
      );
    },
  });

  useEffect(() => {
    setPage(0);
  }, [rowsAmount, filters.source, filters.info, filters.status]);

  return (
    <React.Fragment>
      <ErrorToast toastRef={toast} />
      <CompaniesTable
        companies={data?.companies ?? []}
        totalCompanies={data?.amount ?? 0}
        page={page}
        isFetching={isFetching}
        isError={isError}
        setPage={setPage}
        setRowsAmmount={setRowsAmount}
        rowsAmount={rowsAmount}
        backupData={backupData}
        backupPage={backupPage}
        showStatusColumn={showStatusColumn}
      />
    </React.Fragment>
  );
};

export default CompaniesTableContainer;
